module.exports = __webpack_public_path__ + "img/ice-cream-8081692_1280.77043ee0.png";